// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1T_OJ","tab":"Tabs_tab__d6HUZ","active":"Tabs_active__15bvV","mobile":"Tabs_mobile__3BrW5"};